module.exports = {
  "country": "LT",
  "artist": "LT United",
  "song": "We are the Winner ",
  "year": "2006",
  "place": "6",
  "spotify": "2QNb0E7tUeL5fCQFY5Pf02"
};